import React, {useState} from "react";
import toggleOnImg from "../../Resources/Image/sd_toggle_on.svg";
import toggleOffImg from "../../Resources/Image/sd_toggle_off.svg";

const PlanModalPlanSingle = ({planText, currentPlan = "", description, selectedPlan, setSelect, showWithSMSToggle = false}) => {
    const [toggleOn, setToggleOn] = useState(true);


    const matchCurrentPlan = () => {
        return planText === currentPlan;
    }

    const checkIfSelected = () => {
        return selectedPlan?.includes(planText);
    }

    const handleClick = (ev) => {
        let planTextWithToggle = planText;
        if (showWithSMSToggle && !toggleOn) {
            planTextWithToggle += " (without sms)";
        }
        setSelect(planTextWithToggle);
    }

    const handleToggleClick = (ev) => {
        ev.stopPropagation();
        setToggleOn(!toggleOn);
        let planTextWithToggle = planText;
        if (toggleOn) {
            planTextWithToggle += " (without sms)";
        }
        setSelect(planTextWithToggle);
    }

    return (
        <div className={`px-3 py-5 border rounded single-plan d-flex flex-column justify-content-center ${checkIfSelected() ? 'selected-plan' : ''}`}
             onClick={handleClick}>
            <div className="fs-5 fw-bold planName">
                {planText}
                {matchCurrentPlan() && <div className="fs-6 fw-light">(Current Plan)</div>}
            </div>
            {showWithSMSToggle && <div className="d-flex justify-content-center py-2" onClick={handleToggleClick}>
                <div className="sd-toggle">
                    <img src={toggleOn ? toggleOnImg : toggleOffImg} alt={"on-off"}/>
                </div>
                <div className="ps-2">with SMS</div>
            </div>}
            {
                !showWithSMSToggle && <div className="toggle-empty-space"></div>
            }
            {description && (
                <div className="fw-lighter text-center text-muted mt-1" style={{fontSize: '0.75rem', height: '2.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6c757d'}}>
                    {description}
                </div>
            )}

        </div>
    )
}

export default PlanModalPlanSingle;
